var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckmark = function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 448 512",
    xmlns: "http://www.w3.org/2000/svg",
    width: "2rem",
    height: "2rem"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M413.505 91.951L133.49 371.966l-98.995-98.995c-4.686-4.686-12.284-4.686-16.971 0L6.211 284.284c-4.686 4.686-4.686 12.284 0 16.971l118.794 118.794c4.686 4.686 12.284 4.686 16.971 0l299.813-299.813c4.686-4.686 4.686-12.284 0-16.971l-11.314-11.314c-4.686-4.686-12.284-4.686-16.97 0z"
  })));
};
export default SvgCheckmark;